// Applies the resolved theme to <html data-theme="...">. The store holds
// the user preference (light | dark | system); when "system", we follow
// prefers-color-scheme and live-update on changes.
import { useEffect } from "react";
import { useExplorerStore, type Theme } from "../store/explorerStore";

function prefersDark(): boolean {
  return typeof window !== "undefined"
    && typeof window.matchMedia === "function"
    && window.matchMedia("(prefers-color-scheme: dark)").matches;
}

function resolve(theme: Theme): "light" | "dark" {
  if (theme !== "system") return theme;
  return prefersDark() ? "dark" : "light";
}

export function useTheme() {
  const { theme, setTheme } = useExplorerStore();

  useEffect(() => {
    const apply = () => {
      document.documentElement.setAttribute("data-theme", resolve(theme));
    };
    apply();
    if (theme !== "system") return;
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    mql.addEventListener("change", apply);
    return () => mql.removeEventListener("change", apply);
  }, [theme]);

  return { theme, setTheme };
}
